import { BooLogo } from "@/components/BooLogo";
import { PreviewShell } from "./PreviewShell";

// Minimal preview for the very first onboarding step. The org-step
// preview shows what Boo can do; here we just want a warm "hi" — a
// single pulsing logo and one short tagline.
export function WelcomePreview() {
  return (
    <PreviewShell
      background="linear-gradient(135deg, #faf7fb 0%, #f0eef5 50%, #f5eef0 100%)"
      dotColors={["#D4537E", "#7F77DD", "#534AB7", "#EF9F27"]}
    >
      <div className="flex justify-center">
        <div className="relative">
          <span
            className="boo-pulse absolute -inset-10 rounded-full"
            style={{
              background:
                "radial-gradient(closest-side, rgba(127, 119, 221, 0.45), transparent 70%)",
            }}
          />
          <span
            className="boo-pulse absolute -inset-14 rounded-full"
            style={{
              background:
                "radial-gradient(closest-side, rgba(212, 83, 126, 0.25), transparent 70%)",
              animationDelay: "400ms",
            }}
          />
          <BooLogo className="relative size-24 rounded-2xl" />
        </div>
      </div>
    </PreviewShell>
  );
}
